import { render, staticRenderFns } from "./ComplaintsSampleMonitoring.vue?vue&type=template&id=6f57bb8e"
import script from "./ComplaintsSampleMonitoring.vue?vue&type=script&lang=js"
export * from "./ComplaintsSampleMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports